export const KEY_REDUCER_SHARE = "share";
